import NewCourseForm from './NewCourseForm'
import { useGetUsersQuery } from '../users/usersApiSlice'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'

const NewCourse = () => {
    useTitle('techCourses: New Course')


    const content = <NewCourseForm  />

    return content
}
export default NewCourse